Backbone = require 'backbone'
Backbone.$ = $
SupportLiveChatTemplate = require('../../live_chat.html.mustache')
SupportLiveChatFloatingTemplate = require('../../live_chat_floating.html.mustache')

class SupportLiveChatView extends Backbone.View
  id: 'live-chat'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @model = @options.model
    @setTemplates()
    @I18nScope = 'modules.support'
    @liveChatImageInterval = setInterval(() ->
      bcfloating = $(".bcFloat img, .bcStatic img");
      bcanchor = $(".bcFloat a, .bcStatic a")
      if (bcfloating.length)
        bcfloating.attr("alt", I18n.translate('js.modules.support.chat_us'))
        bcanchor.removeAttr("href").attr({
          "role":"button",
          "aria-label": I18n.translate('js.modules.support.chat_us'),
          "tabindex":"0"
        })
    , 3000)

    @liveChatTextInterval = setInterval(() ->
      bcanchor = $(".bcText a")
      if (bcanchor.length)
        bcanchor.removeAttr("href").attr({
          "role":"button",
          "aria-label": I18n.translate('js.modules.support.chat_us'),
          "tabindex":"0"
        })
    , 3000)

  render: (params) ->
    unless params.startFromSameViewState then @$el.empty()
    @templates = window.getInArrayFormat @getTemplatesToRender()
    _.each @templates, (template) =>
      @setIntialQuestion(params)
      @$el.append toHtml(template, @model.toJSON(), @I18nScope)
    this

  setIntialQuestion: (params) ->
    @model.setIntialQuestion(params)

  getTemplatesToRender: ->
    if @model.has(@model.get('mode')) then @model.get(@model.get('mode')) else @model.get('floating')

  setLiveChat: (mode, liveChatType) ->
    if @shouldRenderLiveChat()
      @model.setLiveChatInfo liveChatType
      @model.set {mode: mode || 'static'}

  renderView: (viewElem, params = {})->
    if @shouldRenderLiveChat()
      liveChatConfig =  @model.get('liveChat')
      if liveChatConfig && liveChatConfig.accountID
        @render(params)
        viewElem.append(@$el)

  shouldRenderLiveChat: ()->
    @model.isLiveChatEnabled() and
    @checkForRefundEligibleConditionsToDisplayLiveChat()

  checkForRefundEligibleConditionsToDisplayLiveChat: ()->
    if evaluate Groupon.Support.ContentModel.isRefundEligible
      Groupon.Support.currentOrder?.STATE?.toUpperCase() is 'AVAILABLE'
    else true

  setTemplates: () ->
    @model.set {'static': SupportLiveChatTemplate}
    @model.set {'floating': SupportLiveChatFloatingTemplate}
    @model.set {'both': [@model.get('static'), @model.get('floating')]}

module.exports = SupportLiveChatView
